import React from "react";

import FormattedAmount from "pages/_components/FormattedAmount";
import { string, number, oneOfType, oneOf } from "prop-types";

import I18n from "../../I18n";
import { textTypes, currencies } from "../customTextPropType";

const FormmatedText = ({ text, textType, toLower }) => {
    if (textType === "MONEY") {
        return <FormattedAmount quantity={Number(text)} currency="ARS" />;
    }
    if (currencies.includes(textType)) {
        return <FormattedAmount quantity={Number(text)} currency={textType} />;
    }
    if (textType === "NUMBER") {
        return text
            .toFixed(2)
            .replace(".", ",")
            .replace(/\d(?=(\d{3})+,)/g, "$&.");
    }
    if (textType === "PERCENTAGE") {
        return `${Number(text)
            .toFixed(2)
            .replace(".", ",")}%`;
    }
    if (textType === "DATE") {
        const date = new Date(text);
        date.setDate(date.getDate() + 1);

        const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
        const month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(date);
        const day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
        return `${day}/${month}/${year}`;
    }
    if (textType === "I18N") {
        return <I18n id={text} />;
    }
    if (textType === "TEXT") {
        if (toLower === true) {
            return text.toLowerCase();
        }
    }

    return text;
};

FormmatedText.propTypes = {
    text: oneOfType([string, number]).isRequired,
    textType: oneOf(textTypes),
    toLower: string,
};

FormmatedText.defaultProps = {
    textType: "STRING",
    toLower: false,
};

export default FormmatedText;
